import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useActivityParent } from "PFApp/activities/show/hooks/use_activity_parent";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { ActivityAudience } from "PFApp/components/activity_commons/activity_audience";
import { ActivityResourcingDates } from "PFApp/components/activity_commons/activity_resourcing_dates";
import { Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Tile } from "PFComponents/tile";

import { ActivityCreator } from "./activity_creator";
import { ActivityParent } from "./activity_parent";
import { ActivityProfilesSection } from "./activity_profiles_section";
import css from "./activity_summary.module.scss";
import { ActivityVacancies } from "./activity_vacancies";
import { ActivityWatchers } from "./activity_watchers";

export const ActivitySummary = () => {
  const activity = useCurrentActivity();
  const { isRole } = useActivityShowContext();
  const parentActivity = useActivityParent(activity);

  return (
    <Tile paddingVariant="lg" className={css.root} variant="selected">
      <Stack gap="spacingLg">
        <ActivityProfilesSection />
        <Divider />

        <ActivityResourcingDates activity={activity} />
        <Divider />

        {parentActivity && (
          <>
            <ActivityParent parentActivity={parentActivity} />
            <Divider />
          </>
        )}

        {isRole && activity.coowned && (
          <>
            <ActivityVacancies />
            <Divider />
          </>
        )}

        <ActivityAudience activity={activity} />
        <Divider />

        {!activity.coowned && activity.watchers?.length && (
          <>
            <ActivityWatchers />
            <Divider />
          </>
        )}

        <ActivityCreator />
      </Stack>
    </Tile>
  );
};
